/* eslint-disable @typescript-eslint/camelcase */
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { Component, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import LoadingSpinner from '@core/components/LoadingSpinner.vue'
import { IDateService } from '@master/services/IDateService'
import { Assumptions } from './model/Assumptions'
import { FormStructure } from '@master/model/structure/FormStructure'

@Component({
  components: {
    AppForm,
    LoadingSpinner
  }
})
export class AssumptionsAdminMixin extends Vue {
  @inject()
  protected dateService: IDateService

  @inject()
  protected $api: API

  protected loading = false
  protected assumptions: Assumptions = new Assumptions()

  get assumptionStructure (): FormStructure<Assumptions> {
    return [
      {
        label: 'Annual Inflation (%)',
        key: 'annualinflation',
        type: 'number',
        classes: ['colspan']
      },
      {
        label: 'Annual Investment Return (%)',
        key: 'annualinvestmentreturn',
        type: 'number',
        classes: ['colspan']
      },
      {
        label: 'Annual Increase in Education Costs (%)',
        key: 'increaseineducationcosts',
        type: 'number',
        classes: ['colspan']
      },
      {
        label: 'Annual Salary Increment (%)',
        key: 'annualsalaryincrement',
        type: 'number',
        classes: ['colspan']
      },
      {
        label: 'Retirement Income (% of last drawn pre-retirement salary)',
        key: 'retirementincome',
        type: 'number',
        classes: ['colspan']
      }
    ]
  }

  get bscStructure (): FormStructure<Assumptions> {
    return [
      {
        label: 'BSC Specified Variable Income (%)',
        key: 'bscSpecifiedIncomeVariable',
        type: 'number',
        classes: ['colspan']
      }
    ]
  }

  async fetchData () {
    try {
      this.loading = true
      const { values } = await this.$api.assumptions.get({
        keys: this.assumptions.getAllRawKeys()
      })
      Object.assign(this.assumptions, this.assumptions.extractData(values))
    } finally {
      this.loading = false
    }
  }

  async save () {
    try {
      this.loading = true

      const assumptionsData = this.assumptions.convertToRawData()
      // Convert Object to a key & value array, and filter if only have value or not null
      const filteredAssumptions = Object.entries(assumptionsData).filter(([key, value]) => value)
      // Convert key & value array back to an Object
      const assumptions_ = Object.fromEntries(filteredAssumptions)

      await this.$api.assumptions.update({
        keyValues: assumptions_
      })
    } finally {
      this.loading = false
    }
  }

  loadDefault () {
    this.assumptions.loadDefault()
  }

  async mounted () {
    await this.fetchData()
    await this.save()
  }
}
